export const blockIconsSearchDoorbell = (
	<span className='material-symbols-outlined'>doorbell</span>
);
